import {Language} from "@/api/data-contracts";

/**
 * Explicit mapping between the generated `Language` enum (NAME values `GERMAN`/`ENGLISH`, also
 * used as the path parameter of the runtime text-bundle endpoint) and the i18next language codes
 * (`de`/`en`). There is no `getValue()` on the generated client, and `"GERMAN".toLowerCase()`
 * would wrongly resolve to `"german"` — this constant is the single source of truth for the
 * translation between the two representations.
 *
 * The map lives in its own module on purpose: it is imported by leaf modules such as
 * `app/locale/muiLocale.ts` (and through it by `lib/utils.ts`). Reading it from `i18nBundle.ts`
 * would drag the i18next initialisation and the whole Axios API client into every module that only
 * needs the two language codes.
 */
export const LANGUAGE_TO_LNG: Record<Language, string> = {
    [Language.GERMAN]: "de",
    [Language.ENGLISH]: "en",
    [Language.POLISH]: "pl",
    [Language.ITALIAN]: "it",
    [Language.FRENCH]: "fr",
    [Language.CZECH]: "cs"
};
